exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator {\n  width: 1px;\n  opacity: 0.8;\n  display: inline-block;\n  background-color: #e4e4e4;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/Separator/Separator.less
// module id = 868
// module chunks = 0